export default __webpack_public_path__ + "static/media/img1.3d97ca5f.jpg";